import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {SupplierOfferRealtimeChange} from "@project/sdk/realtime";

import {supplierOfferKeys} from "../supplierOffer-keys";

type SupplierOfferRealtimeChangeEvent = output<typeof SupplierOfferRealtimeChange>;
export const supplierOffersRealtimeHandler: ResourceChangeRealtimeHandler<SupplierOfferRealtimeChangeEvent> =
  {
    resource: "engineering.supplier-offers",
    queryKey: supplierOfferKeys.all,
    eventSchema: SupplierOfferRealtimeChange,
    async handleEvent(_event, queryClient) {
      // Resource-wide reconciliation covers both pair dimensions and every parent-filtered list.
      await queryClient.invalidateQueries({queryKey: supplierOfferKeys.all});
    },
  };
